import React from "react";
import { Field } from "formik";
import get from "lodash.get";

export default class FormInputUpdate extends React.PureComponent {
  render() {
    const {
      children,
      className,
      component,
      disabled,
      readOnly,
      errors,
      label,
      labelClassNames,
      labelTag,
      name,
      touched,
      type,
      validate,
      style,
      ...props
    } = this.props;
    const error = get(errors, name) && get(touched, name);
    return (
      <React.Fragment>
        {label && (
          <label
            className={`line-height-double ${
              labelClassNames ? labelClassNames : "accent-text small-text"
            } ${className === "form-required" ? "form-required" : ""} ${
              error ? "error" : ""
            }`}
          >
            {label}
          </label>
        )}
        {labelTag && labelTag}
        <Field
          name={name}
          className={`custom-input ${error ? "error" : ""} ${
            className ? className : ""
          }`}
          component={component}
          type={type}
          validate={validate}
          {...props}
          disabled={disabled}
          readOnly={readOnly}
        >
          {children ? children : null}
        </Field>
      </React.Fragment>
    );
  }
}
